export const registerColors = {
  backgroundPanel: '#111217',
  backgroundButton: '#1E1F25',
  borderSubtle: '#FFFFFF1A',
  dividerColor: '#FFFFFF33',
  textLink: '#CCD4FF',
  textMuted: '#9CA3AF',
  textBody: '#D1D5DB',
  checkboxColor: '#FFFFFF33',
} as const;
